export {};
//# sourceMappingURL=performance.js.map